import type { ViewQueryField } from '@salescore/core'
import type { ModalFuncProps } from 'antd'
import { t } from 'i18next'
import type { ReactNode } from 'react'

import { useSetQueryField, useViewConfigSheet } from '../../../../recoil/viewConfig'
import { SearchSqlForm } from './SearchSqlForm'

interface ModalAtomHook<T> {
  isModalVisible: boolean
  content: T | undefined
  showModal: (content: T) => void
  hideModal: () => void
}

export const buildSearchSqlFormModalProperties = ({
  content,
  onAfterFinish,
  setHasChangeToViewSchema,
}: {
  content: ModalAtomHook<ViewQueryField>['content']
  onAfterFinish: () => void
  setHasChangeToViewSchema: (hasChangeToViewSchema: boolean) => void
}): ModalFuncProps => ({
  icon: null,
  width: '90%',
  okButtonProps: { style: { display: 'none' } },
  cancelText: t(`閉じる`),
  maskClosable: true,
  content: (
    <SearchSqlFormBody
      content={content}
      onAfterFinish={onAfterFinish}
      setHasChangeToViewSchema={setHasChangeToViewSchema}
    />
  ),
  style: { maxWidth: 1000 },
  destroyOnClose: true,
})

export const SearchSqlFormBody = ({
  content,
  onAfterFinish,
  setHasChangeToViewSchema,
}: {
  content: ModalAtomHook<ViewQueryField>['content']
  onAfterFinish: () => void
  setHasChangeToViewSchema: (hasChangeToViewSchema: boolean) => void
}): ReactNode => {
  const config = useViewConfigSheet()
  const setQueryField = useSetQueryField()
  const field = content

  return (
    field !== undefined && (
      <SearchSqlForm
        title={t(`参照カラムの検索設定`)}
        editNode={(sql: string) => {
          setQueryField({
            config,
            field,
            override: {
              read: {
                searchSql: sql,
              },
            },
            onSetConfig: () => {
              setHasChangeToViewSchema(true)
            },
          })
        }}
        onAfterFinish={onAfterFinish}
        sql={field.read.searchSql ?? ''}
      />
    )
  )
}
